import { useEffect } from "react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Reveal, Overline } from "../components/site/Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function LegalPage({ docKey }) {
  const { t } = useLang();
  const doc = t.legal[docKey];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [docKey]);

  return (
    <div className="font-body bg-background text-nero-ink antialiased min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16 lg:pt-[72px]">
        <section className="bg-white border-b border-border" data-testid={`legal-hero-${docKey}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
            <Reveal>
              <Overline>{doc.kicker}</Overline>
              <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter text-nero-ink leading-[1.0]">
                {doc.title}
              </h1>
              <p className="mt-6 font-body text-sm text-zinc-500">{doc.updated}</p>
            </Reveal>
          </div>
        </section>

        <section className="bg-background">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
            <div className="max-w-3xl space-y-12">
              {doc.sections.map((s, i) => (
                <Reveal key={i} delay={0.04}>
                  <div data-testid={`legal-section-${i}`}>
                    <h2 className="font-heading text-xl sm:text-2xl font-medium tracking-tight text-nero-ink">
                      <span className="text-nero-green mr-3 tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                      {s.h}
                    </h2>
                    <div className="mt-4 space-y-3">
                      {s.body.map((p, j) => (
                        <p key={j} className="font-body text-base leading-relaxed text-zinc-600">{p}</p>
                      ))}
                    </div>
                  </div>
                </Reveal>
              ))}
              <Reveal>
                <p className="font-body text-sm leading-relaxed text-zinc-400 border-t border-border pt-8">
                  {doc.note}
                </p>
              </Reveal>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
